<template>
	<div
		id="thread-list"
		class="overflow-y-auto max-h-full w-full md:w-2/5 xl:w-1/3 border-r border-gray-300"
		:class="{ 'd-none d-md-block': !showListOnMobile }"
	>
		<div class="px-4 sm:px-6 lg:px-6 py-4 lg:py-6">
			<div class="bg-white w-full shadow rounded-lg md:overflow-hidden">
				<ul role="list" class>
					<!--divide-y divide-gray-200-->
					<li
						:class="[
							'p-4 hover:bg-gray-50 active:bg-gray-150',
							thread.id == (activeThread || {}).id
								? 'md:pr-2 md:border-r-8 md:border-green-500 border-gray-200 border-b'
								: 'border-gray-200 border-b',
							countUnreadEvents(thread) > 0 ? 'probably-no-todo-anymore' : '',
						]"
						v-on:click="setActiveThread(thread)"
						v-for="thread in threads"
						:key="thread.id"
					>
						<!-- TO DO reading the message does not change the sate of countUnreadEvents(thread) -->

						<thread-list-item
							:thread="thread"
							:key="thread.id"
							:unread="countUnreadEvents(thread)"
							v-bind:should-go-to-thread="false"
						/>
					</li>
				</ul>
			</div>

			<!-- Sentinel fuers Infinite Loading: wird er (dank rootMargin schon kurz vorher) im
			     Scroll-Container sichtbar, feuert der Observer load-more. Immer im DOM, damit die
			     ref stabil bleibt; maybeLoadMore() prueft hasMore/isLoadingMore. -->
			<div ref="loadMoreSentinel" class="h-px"></div>

			<div class="mt-4 flex justify-center" v-if="isLoadingMore">
				<ui-loading-spinner :size="10" />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		threads: {
			type: Array,
			required: true,
		},
		activeThread: {
			type: Object,
			required: false,
		},
		showListOnMobile: {
			type: Boolean,
			required: false,
		},
		hasMore: {
			type: Boolean,
			required: false,
			default: false,
		},
		isLoadingMore: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	data() {
		return {
			showContactInfo: false,
			uploadOpen: false,
			sentinelObserver: null,
			sentinelVisible: false,
		};
	},
	mounted() {
		// root = null (Viewport): die Sichtbarkeit richtet sich nach dem tatsaechlichen Bildschirm,
		// inkl. Clipping durch den jeweils scrollenden Vorfahren (innere Spalte auf Desktop, Body
		// auf Mobile). Nicht #thread-list als root nehmen — das Element ist nur auf Desktop selbst
		// der Scroll-Container; auf Mobile waechst es unbegrenzt, wodurch der Sentinel permanent
		// "sichtbar" waere und beim Initial-Load saemtliche Seiten kaskadierend nachgeladen wuerden.
		// rootMargin "100%" = eine Viewport-Hoehe: die naechste Seite wird ~1 Viewport vor dem Ende
		// vorausgeladen. Prozent statt fixer px, weil der root der Viewport ist → skaliert mit dem Geraet.
		this.sentinelObserver = new IntersectionObserver(
			(entries) => {
				this.sentinelVisible = entries[0].isIntersecting;
				this.maybeLoadMore();
			},
			{ root: null, rootMargin: "100% 0px" }
		);
		this.sentinelObserver.observe(this.$refs.loadMoreSentinel);
	},
	beforeDestroy() {
		if (this.sentinelObserver) {
			this.sentinelObserver.disconnect();
			this.sentinelObserver = null;
		}
	},
	watch: {
		// Nach dem Nachladen den Sentinel-Zustand vom Observer NEU liefern lassen. Der Observer
		// feuert von sich aus nicht, solange der Sentinel durchgehend sichtbar bleibt — deshalb
		// re-observe (unobserve + observe erzwingt einen frischen Callback mit der TATSAECHLICHEN
		// Sichtbarkeit). Bleibt der Sentinel sichtbar (neue Seite fuellt den Container nicht), wird
		// weitergeladen; ist er durch die angehaengte Seite aus dem Blick gerueckt, nicht. Frueher
		// las die Pruefung das veraltete sentinelVisible (noch true) und loeste so eine zweite,
		// ungewollte Seite pro Scroll aus.
		isLoadingMore(loading) {
			if (loading) {
				return;
			}

			this.$nextTick(() => {
				if (this.sentinelObserver && this.$refs.loadMoreSentinel) {
					this.sentinelObserver.unobserve(this.$refs.loadMoreSentinel);
					this.sentinelObserver.observe(this.$refs.loadMoreSentinel);
				}
			});
		},
	},
	methods: {
		countUnreadEvents(thread) {
			return thread.unread_events_count ?? 0;
		},
		maybeLoadMore() {
			if (this.sentinelVisible && this.hasMore && !this.isLoadingMore) {
				this.$emit("load-more");
			}
		},
		setActiveThread(thread) {
			this.$emit("toggle-show-list-on-mobile", false);
			if (this.activeThread && this.activeThread.id == thread.id) {
				return; // thread already active
			}
			this.$emit("new-active-thread", thread);
		},
	},
};
</script>
